import React, { useEffect, useState } from 'react';
import { Play, Pause, ChevronLeft, ChevronRight } from 'lucide-react';
import { featuredHero } from '../mock';
import { usePlayer } from '../context/PlayerContext';

const CAROUSEL_INTERVAL_MS = 6000;
const HERO_COUNT = featuredHero.length;

const HeroCarousel = () => {
  const [idx, setIdx] = useState(0);
  const { play, current, isPlaying, togglePlay } = usePlayer();

  useEffect(() => {
    const t = setInterval(
      () => setIdx((i) => (i + 1) % HERO_COUNT),
      CAROUSEL_INTERVAL_MS
    );
    return () => clearInterval(t);
  }, []);

  const item = featuredHero[idx];
  const isThisPlaying = current?.id === item.id && isPlaying;

  const handlePlay = () => {
    if (current?.id === item.id) {
      togglePlay();
    } else {
      play({ id: item.id, title: item.title, artist: item.artist, cover: item.image, duration: '4:12' });
    }
  };

  return (
    <section className="relative mt-4 mx-6 rounded-2xl overflow-hidden border border-white/5">
      <div
        className="h-[340px] md:h-[380px] relative bg-cover bg-center transition-all duration-700"
        style={{ backgroundImage: `url(${item.image})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/60 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />

        <div className="relative h-full flex items-end p-8 md:p-10">
          <div className="fade-slide max-w-2xl" key={item.id}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-500/15 border border-orange-500/30 text-orange-300 text-[11px] font-semibold tracking-wider">
              {item.tag}
            </div>
            <h1 className="font-display text-4xl md:text-6xl leading-[1.05] text-white mt-4">
              {item.title}
            </h1>
            <p className="text-neutral-300 text-sm md:text-base mt-3">{item.artist}</p>

            <div className="flex items-center gap-3 mt-6">
              <button
                onClick={handlePlay}
                className="w-14 h-14 rounded-full bg-white hover:bg-neutral-200 text-black flex items-center justify-center shadow-lg shadow-black/50 transition-transform hover:scale-105"
              >
                {isThisPlaying ? <Pause className="w-6 h-6" fill="currentColor" /> : <Play className="w-6 h-6 ml-0.5" fill="currentColor" />}
              </button>
              <button className="px-5 py-3 text-sm font-semibold text-white border border-white/25 rounded-full hover:bg-white/10 transition-colors">
                Add to Crate
              </button>
            </div>
          </div>
        </div>

        {/* Arrows */}
        <button
          onClick={() => setIdx((i) => (i - 1 + featuredHero.length) % featuredHero.length)}
          className="absolute top-1/2 -translate-y-1/2 left-4 w-9 h-9 rounded-full bg-black/50 hover:bg-black/70 border border-white/10 text-white flex items-center justify-center transition-colors"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <button
          onClick={() => setIdx((i) => (i + 1) % featuredHero.length)}
          className="absolute top-1/2 -translate-y-1/2 right-4 w-9 h-9 rounded-full bg-black/50 hover:bg-black/70 border border-white/10 text-white flex items-center justify-center transition-colors"
        >
          <ChevronRight className="w-5 h-5" />
        </button>

        {/* Dots */}
        <div className="absolute bottom-4 right-6 flex gap-1.5">
          {featuredHero.map((slide, i) => (
            <button
              key={slide.id}
              onClick={() => setIdx(i)}
              className={`h-1.5 rounded-full transition-all ${i === idx ? 'bg-orange-400 w-6' : 'bg-white/30 w-3 hover:bg-white/50'}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroCarousel;
